'use client';

import React, { createContext, useContext, useState, useCallback, useEffect } from 'react';

const LoadingContext = createContext();

export function LoadingProvider({ children }) {
  const [isLoading, setIsLoading] = useState(true);
  const [minLoadingTime] = useState(2000); // 2 seconds minimum
  const [isInitialLoad, setIsInitialLoad] = useState(true);

  const showLoading = useCallback(() => {
    // Only show loading on initial load, not on route changes
    if (isInitialLoad) {
      setIsLoading(true);
    }
  }, [isInitialLoad]);

  const hideLoading = useCallback(() => {
    // Only hide if it's the initial load
    if (isInitialLoad) {
      // Ensure minimum 2 second display
      const elapsed = Date.now() - (window.__loadingStartTime || Date.now());
      const remainingTime = Math.max(0, minLoadingTime - elapsed);
      
      console.log('[LoadingContext] hideLoading called:', { elapsed, remainingTime, minLoadingTime });
      
      if (remainingTime > 0) {
        setTimeout(() => {
          console.log('[LoadingContext] Setting isLoading to false after delay');
          setIsLoading(false);
          setIsInitialLoad(false);
        }, remainingTime);
      } else {
        console.log('[LoadingContext] Setting isLoading to false immediately');
        setIsLoading(false);
        setIsInitialLoad(false);
      }
    }
  }, [isInitialLoad, minLoadingTime]);

  useEffect(() => {
    // Record start time when provider mounts (only on app init)
    if (typeof window !== 'undefined' && isInitialLoad) {
      window.__loadingStartTime = Date.now();
      console.log('[LoadingContext] Provider mounted - starting initial load timer');
    }
  }, [isInitialLoad]);

  return (
    <LoadingContext.Provider value={{ isLoading, showLoading, hideLoading, isInitialLoad }}>
      {children}
    </LoadingContext.Provider>
  );
}

export function useLoading() {
  const context = useContext(LoadingContext);
  if (!context) {
    throw new Error('useLoading must be used within LoadingProvider');
  }
  return context;
}
